import { SignRequestCard } from 'app-view/components/SignRequest/steps/BitcashSignRequestCard'
import { LoadingSignature } from 'app-view/components/SignRequest/steps/LoadingSignature'
import { QRReaderCard } from 'app-view/components/SignRequest/steps/QRReaderCard'
import { SignSuccess } from 'app-view/components/SignRequest/steps/SignSuccess'
import { WizardStep } from 'app-view/components/Wizard'

export const SIGNING_REQUEST_STEPS: WizardStep[] = [
  {
    name: 'loading_signature',
    component: LoadingSignature,
  },
  {
    name: 'qr_reader',
    component: QRReaderCard,
  },
  {
    name: 'sign_request',
    component: SignRequestCard,
  },
  {
    name: 'sign_success',
    component: SignSuccess,
  },
]
